import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/stores/user'
import { usePluginsStore } from '@/stores/plugins'

function useHandoverAvailability() {
  const { canCreateConsultations, hasGodModeShift, hasHospitalItRole, hasTccItRole } =
    storeToRefs(useUserStore())
  const { isConnectEnabled } = storeToRefs(usePluginsStore())

  const isHandoverAvailable = computed<boolean>(
    () =>
      isConnectEnabled.value &&
      canCreateConsultations.value &&
      !hasGodModeShift.value &&
      !hasHospitalItRole.value &&
      !hasTccItRole.value
  )

  return { isHandoverAvailable }
}

export default useHandoverAvailability
